
import Vue, { PropType } from 'vue';
import { formatAgentQuantity, getTerritoryAccess } from '@/utils';
import createTerritoryAccessRequest from '@/services/territory-access/create';
import { getAgent } from '@/services/user/get-agent';
import { getCofre } from '@/services/tickets/get-cofre';
import { TerritoryInfo } from '../../config/types';
import Modal from '../Modal/index.vue';
import Button from '../Button/index.vue';
import Card from '../Card/index.vue';
import {
  AccessDetails, HeadDetails, Label, Requested, Wrapper,
} from './styles';

export default Vue.extend({
  name: 'ResultSearch',
  components: {
    AccessDetails,
    Button,
    Card,
    HeadDetails,
    Label,
    Requested,
    Wrapper,
    Modal,
  },
  props: {
    territoryInfo: Object as PropType<TerritoryInfo>,
    isAdminUser: {
      type: Boolean,
      default: false,
    },
    document: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isModalActivated: false,
      buttonDisable: false,
      documentProp: '',
      digitalSafe: '',
      contestationCondition: false,
      userLoged: JSON.parse(sessionStorage.getItem('userLogged') as string),
      modalButtons: [
        {
          click: 'closeModal',
          title: 'Ok, voltar',
          type: 'primary',
        },
      ],
    };
  },
  methods: {
    goToDetails(id: number, name: string, document: string) {
      this.$router.push(`admin/territorioInfo/${id}/${name}/${document}`);
    },
    formatAgent(agents: []) {
      return formatAgentQuantity(agents);
    },
    formatTerritoryAccessMessage(territoryAccess: number) {
      return getTerritoryAccess(territoryAccess);
    },
    async makeRequest(territoryId: string) {
      this.buttonDisable = true;
      const userLogged = sessionStorage.getItem('userLogged') as string;
      const parse = JSON.parse(userLogged);
      const { idUser, company } = parse;

      const responseCreate = {
        frigId: idUser.toString(),
        territoryId,
        tokenKey: company.stKey.toString(),
      };
      const territory = await createTerritoryAccessRequest(responseCreate);
      if (!territory.hasError) {
        this.isModalActivated = true;
      }
      // this.isModalActivated = true;
    },
    closeModal() {
      this.isModalActivated = false;
      this.buttonDisable = false;
    },
  },
  async created() {
    this.documentProp = this.document;
    const tokenKey = this.userLoged.company.stKey;
    const document = this.documentProp.replace(/[^0-9]/g, '');
    const agentId = await getAgent({ tokenKey, document });
    const agentIdItem = agentId.id;
    const response = await getCofre(tokenKey, agentIdItem);
    response.map((e) => {
      if (e.cdTerritory === this.territoryInfo.id) {
        e.digitalSafes.map((k) => {
          if (k.vlUrlDownload !== '' && k.nmFileType?.toUpperCase()?.includes('CONTDOC')) {
            this.digitalSafe = k.vlUrlDownload;
            return k;
          }
          return false;
        });
        return e;
      }
      return false;
    });
  },
});
